// Libraries
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import * as _ from "lodash";
import { Observable } from "rxjs";
// import { User, UserService } from "../../../user";

@Component({
  selector: "calendar-ais",
  template: require("./CalendarComponent.html"),
  styles: [require("./CalendarComponent.sass")],
})
export class CalendarComponent implements OnInit {
  // private userData: User;

  constructor(private router: Router) {}

  ngOnInit() {
    //check auth later
    // this.userData = this.userService.getUserSessionData();
    // if (!this.userData) {
    //   this.router.navigate(["/"]);
    // }
  }
}



// WEBPACK FOOTER //
// ./src/common/modules/shared/components/calendar/CalendarComponent.ts